import Api from "../../utils/axios";

const preSuggestionApi = {
    addPreSuggestion: (payload) => Api.post(`admin/create-pre-suggestion`,payload),
    editPreSuggestion: (id,payload) => Api.put(`admin/update-pre-suggestion/${id}`,payload),
    getAllPreSuggestion: (payload) => Api.post(`admin/get-all-pre-suggestions`,payload),
    deletePreSuggestion: (id, payload) => Api.delete(`admin/delete-pre-suggestion/${id}`,payload),
}

export default preSuggestionApi